import React, {useState} from 'react';
import axios from "axios";
import './LoginForm.css';
import { withRouter } from "react-router-dom";
const url = "/api/users/";

function LoginForm(props) {
    const [state , setState] = useState({
        email : "",
        password : "",
        successMessage: null
    })
    const handleChange = (e) => {
        const {id , value} = e.target   
        setState(prevState => ({
            ...prevState,
            [id] : value
        }))
    }

    const handleSubmitClick = (e) => {
        e.preventDefault();
        // const payload={
        //     "email":state.email,
        //     "password":state.password,
        // }
        axios.post(url+"login",{"email": state.email, "password": state.password})
           .then((response) => {
               if(response.status >= 200 && response.status < 300) {
                    // setState(prevState => ({
                    //     ...prevState,
                    //     'successMessage' : 'Login successful. Redirecting to home page..'
                    // }))
                    props.history.push('/connect');
                }
            })
            .catch(function (error) {
                console.log(error);
                RedirectToSigninErr();
            });
    }

    const redirectToRegister = () => {
        props.history.push('/Signup'); 
    }

    // const RedirectPage = () => {
    //     props.history.push('/connect'); 
    // }

    const RedirectToSigninErr = () => {
        props.history.push('/SigninErr'); 
    }

    return(
        <div className="card col-12 col-lg-4 login-card mt-2 hv-center">
            <form>
                <div className="form-group text-left">
                <label htmlFor="exampleInputEmail1"> Email Address</label>
                <input type="email" 
                       className="form-control" 
                       id="email" 
                       aria-describedby="emailHelp" 
                       placeholder="Enter Email" 
                       value={state.email}
                       onChange={handleChange}
                />
                <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                </div>
                <div className="form-group text-left">
                <label htmlFor="exampleInputPassword1">Password</label>
                <input type="password" 
                       className="form-control" 
                       id="password" 
                       placeholder="Enter Password"
                       value={state.password}
                       onChange={handleChange} 
                />
                </div>
                <div className="form-check">
                </div>
                <button 
                    type="submit" 
                    className="btn btn-primary"
                    onClick={handleSubmitClick}
                >Submit</button>
            </form>
            <div className="alert alert-success mt-2" style={{display: state.successMessage ? 'block' : 'none' }} role="alert">
                {state.successMessage}
            </div>
            <div className="registerMessage">
                <span>Dont have an account? </span>
                <span className="loginText" onClick={() => redirectToRegister()}>Register</span> 
            </div>
        </div>
    )
}

export default withRouter(LoginForm);